import React, { useState } from 'react';
import { useCart } from '../CartContext';
import ProductDetailModal from './ProductDetailModal';
import toast from 'react-hot-toast';
import './ProductCard.css';

export default function ProductCard({ product }) {
  const { dispatch, items } = useCart();
  const [adding, setAdding] = useState(false);
  const [imgErr, setImgErr] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const cartItem = items.find(i => i.id === product.id);

  const handleAdd = (e) => {
    e.stopPropagation();
    setAdding(true);
    dispatch({ type: 'ADD_ITEM', item: product });
    toast.success(`${product.name} added!`, { duration: 1400, icon: '🛒' });
    setTimeout(() => setAdding(false), 400);
  };

  const handleQtyChange = (e, delta) => {
    e.stopPropagation();
    dispatch({ type: 'UPDATE_QTY', id: product.id, qty: (cartItem?.qty || 0) + delta });
  };

  const wishlisted = JSON.parse(localStorage.getItem('freshmart_wishlist') || '[]').includes(product.id);

  return (
    <>
      <div className={`product-card ${adding ? 'pop' : ''}`} onClick={() => setShowModal(true)}>
        <div className="product-img-wrap">
          {!imgErr ? (
            <img src={product.image} alt={product.name} onError={() => setImgErr(true)} loading="lazy" />
          ) : (
            <div className="img-fallback" style={{ background: `${product.color}22` }}>
              <span style={{ fontSize: 48 }}>{product.name[0]}</span>
            </div>
          )}
          {product.badge && <span className="product-badge">{product.badge}</span>}
          {wishlisted && <span className="wishlist-dot">❤️</span>}
          <div className="product-rating">⭐ {product.rating}</div>
          {product.stock < 15 && <div className="low-stock-tag">Low Stock</div>}
          <div className="quick-view-overlay">
            <span>👁 Quick View</span>
          </div>
        </div>

        <div className="product-info">
          <p className="product-category">{product.category}</p>
          <h3 className="product-name">{product.name}</h3>
          {product.description && <p className="product-desc">{product.description}</p>}
          <p className="product-reviews">👤 {product.reviews} reviews</p>

          <div className="product-footer">
            <div className="product-price">
              <span className="price-symbol">₹</span>
              <span className="price-amount">{product.price}</span>
              <span className="price-unit">/{product.unit}</span>
            </div>

            {cartItem ? (
              <div className="qty-control" onClick={e => e.stopPropagation()}>
                <button className="qty-btn" onClick={e => handleQtyChange(e, -1)}>−</button>
                <span className="qty-count">{cartItem.qty}</span>
                <button className="qty-btn qty-btn-add" onClick={e => handleQtyChange(e, 1)}>+</button>
              </div>
            ) : (
              <button className="add-btn" onClick={handleAdd}>
                <span>+</span> Add
              </button>
            )}
          </div>
        </div>
      </div>

      {showModal && <ProductDetailModal product={product} onClose={() => setShowModal(false)} />}
    </>
  );
}
